import { create } from 'zustand';

import { RequestStrategyEnum } from '@shared/api/models';
import { ApiUtils } from '@shared/utils';
import { PostSurveyRequest, SurveyApi } from '@shared/api/rest/survey';

interface PostSurveyType {
  data: string | null;
  loading: boolean;
  error: string | null;
  success: boolean | null;
  create: (request: PostSurveyRequest, surveyId: string, clientId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const usePostSurveyStore = create<PostSurveyType>((set) => ({
  data: null,
  loading: false,
  error: null,
  success: null,

  create: ApiUtils.wrapperApi(async (request: PostSurveyRequest, surveyId: string, clientId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await SurveyApi.postSurvey(request, surveyId, clientId, signal);
      set({ data: result ?? null, success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), success: false, loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, success: null, error: null }),
}));
